export default __webpack_public_path__ + "static/media/ProximaNova-Semibold.255517a5.ttf";